import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';

@Injectable({
    providedIn: 'root'
})
export class ModelosAccesosService extends HttpClientBase {
    constructor(http: HttpClient) {
        super(http, 'modelos/accesos'); // La URL base para el servicio de lotes
    }


    getListModelos() {
        return this.get<any>({ endpoint: '' });
    }
}
